export default angular
  .module("ModifyTitleTranslationCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ModifyTitleTranslationController", [
    "$scope",
    "scriptData",
    "$state",
    "$modalInstance",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "System",
    function (
      $scope,
      scriptData,
      $state,
      $modalInstance,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
      System,
    ) {
      function compare(a, b) {
        if (a.NAME < b.NAME) return -1;
        if (a.NAME > b.NAME) return 1;
        return 0;
      }

      const changedFields = new Map();

      $scope.ok = function () {
        $scope.titletranslations.forEach((entry) => {
          if (changedFields.get(entry.ABBREVIATION)) {
            entry.SCRIPT_ID = scriptData.ID;
            Scripts.updateScriptTitleModal(entry, () => {
              if (entry.LANG == "en") {
                scriptData.TITLE = entry.STR;
              }
            });
          }
        });
        $modalInstance.close();
      };
      $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
      };
      const masterlangdata = {};
      $scope.titletranslations = [];
      $scope.openHistory = function (translationId, lang) {
        let entry = $scope.titletranslations.find((entry) => translationId === entry.ID && lang === entry.LANG)
        entry.SHOWHISTORY = !entry.SHOWHISTORY;
      };
      System.loadLanguages((datalang) => {
        datalang.forEach((entry) => {
          if (entry.ABBREVIATION == "en") {
            masterlangdata.ABBREVIATION = entry.ABBREVIATION;
            masterlangdata.NAME = entry.NAME;
            masterlangdata.STR = scriptData.TITLE;
            masterlangdata.TRANSLATION_STATUS = scriptData.TRANSLATION_STATUS;
            $scope.titletranslations.push(masterlangdata);
          } else {
            Scripts.loadScriptTitlesByID(
              scriptData.ID,
              entry.ABBREVIATION,
              (data) => {
                data[0].ABBREVIATION = entry.ABBREVIATION;
                data[0].NAME = entry.NAME;
                data[0].SHOWHISTORY = false;
                Scripts.loadScriptTitlesHistoryByID(
                  data[0].ID,
                  scriptData.ID,
                  (datahistory) => {
                    data[0].HISTORY = datahistory;
                    $scope.titletranslations.push(data[0]);
                    // sort alphabetically
                    $scope.titletranslations = $scope.titletranslations.sort(compare);
                  },
                );
              },
            );
          }
        });
      });

      $scope.changedField = function (entity, field) {
        changedFields.set(field, true);
      };
    },
  ]);
